import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import ReactPaginate from 'react-paginate';
import JobList from './JobList';
import JobFilter from '../../Jobs/JobsTable/JobFilter';

class JobsTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            offset: 0,
            status: 'all',
            filter: '',
            allusers: false,
            showOnHoldModal: false,
            currentJob: null,
            holdReason: '',
        };
    }

    loadJobsFromServer() {
        let data = {
            limit: this.props.perPage,
            offset: this.state.offset,
            status: this.state.status,
            filter: this.state.filter,
            allusers: this.state.allusers,
        };

        if (this.props.manager_review) {
            data = { ...data, manager_review: this.props.manager_review };
        }

        if (this.props.superadmin_review) {
            data = { ...data, superadmin_review: this.props.superadmin_review };
        }

        this.setState({ loading: true });
        $.ajax({
            url: this.props.url,
            data: data,
            dataType: 'json',
            type: 'GET',
            success: (data) => {
                this.setState({
                    data: data.jobs,
                    pageCount: Math.ceil(data.total / this.props.perPage),
                    loading: false,
                });
            },

            error: (xhr, status, err) => {
                this.setState({ loading: false });
                console.log(this.props.url, status, err.toString());
            },
        });
    }

    componentDidMount() {
        this.loadJobsFromServer();

        if (this.props.success) {
            toastr.success(this.props.success);
        } else if (this.props.error) {
            toastr.error(this.props.error);
        }
    }

    handlePageClick = (data) => {
        let selected = data.selected;
        let offset = Math.ceil(selected * this.props.perPage);

        this.setState({ offset: offset }, () => {
            this.loadJobsFromServer();
        });
    };

    handleClick = (url) => {
        window.open(url, '_blank');
    };

    handleMarkCompleteClick = (job) => {
        let statusLabel;
        let data;

        const isFollowOn = job.status === 'follow-on';
        const isWastedJourney = Number(job.waste_journey) === 1 || job.status === 'wasted_journey';

        if (isFollowOn) {
        statusLabel = 'Follow on';
            data = { status: 'allocated' };
        } else if (isWastedJourney) {
            statusLabel = 'wasted journey';
            data = {
                status: 'completed',
                waste_journey: 1,
            };
        } else {
            statusLabel = 'completed';
            data = {
                status: 'completed',
            };
        }

        const hasPendingManagerReview = job.reviews?.some(
            (review) =>
                review.type === 'manager' &&
                review.review_category === 'approval' &&
                Number(review.approved) === 0
        );
        
        const hasPendingSuperadminReview = job.reviews?.some(
            (review) =>
                review.type === 'superadmin' &&
                review.review_category === 'approval' &&
                Number(review.approved) === 0
        );

        if (this.props.manager_review || hasPendingManagerReview) {
            data.manager_review_approve = 1;
        }

        if (this.props.superadmin_review || hasPendingSuperadminReview) {
            data.superadmin_review_approve = 1;
        }

        data.completed_via_green_tick = 1;

        window.swal
            .fire({
                title: `Mark this job as ${statusLabel}?`,
                text: `Are you sure you want to mark this job as ${statusLabel}?`,
                type: 'question',
                input: 'checkbox',
                inputPlaceholder: 'Recreate the job?',
                showCancelButton: true,
                confirmButtonText: `Mark as ${statusLabel}`,
            })
            .then((isConfirm) => {
                if (isConfirm.dismiss) return;

                $.ajax({
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                    },
                    url: `/jobs/${job.id}/review`,
                    data: isConfirm.value ? { ...data, recreate: 1 } : data,
                    dataType: 'json',
                    type: 'patch',
                    success: () => {
                        location.reload();
                    },
                    error: (res) => {
                        toastr.error(res.responseJSON?.message ?? 'There was a problem, please try again later');
                    },
                });
            });
    };

    handleDelete = (job) => {
        $.get(`/jobs/${job.id}/is-invoiced`, (response) => {
            let title = `Delete job ${job.id}`;
            let text = response.invoiced
                ? 'This job has already been invoiced. Deleting it may cause accounting issues. Are you sure?'
                : 'Are you sure you want to delete this job?';

            window.swal
                .fire({
                    title: title,
                    text: text,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Delete',
                })
                .then((result) => {
                    if (result.dismiss) return;

                    $.ajax({
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                        },
                        url: `/jobs/${job.id}`,
                        type: 'delete',
                        success: () => location.reload(),
                    });
                });
        });
    };

    handleAllUsers = (value) => {
        this.setState(
            {
                allusers: value,
                offset: 0,
            },
            () => {
                this.loadJobsFromServer();
            }
        );
    };

    handleFilter = (e) => {
        this.setState({
            filter: e.target.value,
            offset: 0,
        });
    };

    handleFilterEnter = (e) => {
        if (e.key === 'Enter') {
            this.loadJobsFromServer();
        }
    };

    handleStatus = (e) => {
        this.setState(
            {
                status: e.value,
                offset: 0,
            },
            () => {
                this.loadJobsFromServer();
            }
        );
    };

    toggleOnHold = (job) => {
        this.setState({
            showOnHoldModal: true,
            currentJob: job,
            holdReason: job.review_on_hold_reason || '',
        });
    };

    handleOnHoldSubmit = (e) => {
        e.preventDefault();

        const { currentJob, holdReason } = this.state;
        const isOnHold = !!currentJob.review_on_hold;

        const url = isOnHold ? `/jobs/${currentJob.id}/remove-review-on-hold` : `/jobs/${currentJob.id}/review-on-hold`;

        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            },
            body: JSON.stringify({ reason: holdReason }),
        })
            .then((res) => {
                if (!res.ok) throw new Error();
                return res.json();
            })
            .then(() => {
                toastr.success(isOnHold ? 'Flag removed' : 'Flag added');
                this.setState({ showOnHoldModal: false }, () => {
                    this.loadJobsFromServer(); // refresh job list
                });
            })
            .catch(() => toastr.error('Failed to update flag'));
    };

    closeModal = () => {
        this.setState({ showOnHoldModal: false });
    };

    render() {
        const { showOnHoldModal, currentJob, holdReason } = this.state;
        const isOnHold = currentJob ? !!currentJob.review_on_hold : false;
        const currentReason = holdReason || '';

        // Determine button text and disabled state
        const saveBtnText = isOnHold ? 'Remove Flag' : 'Add Flag';
        const isSaveDisabled = !currentReason.trim();
        return (
            <Fragment>
                <div className="row">
                    <div className="col-12">
                        {this.props.operations ? (
                            <span className="float-right">
                                <button
                                    className={`btn btn-outline-cw-primary ${this.state.allusers ? '' : 'active'} ml-2`}
                                    onClick={() => this.handleAllUsers(false)}
                                >
                                    My Jobs
                                </button>
                                <button
                                    className={`btn btn-outline-cw-primary ${this.state.allusers ? 'active' : ''} ml-2`}
                                    onClick={() => this.handleAllUsers(true)}
                                >
                                    All Jobs
                                </button>
                            </span>
                        ) : null}
                    </div>
                </div>
                <div className="row pt-2">
                    <div className="col-12">
                        <div className="cw-bg-grey py-1 d-flex justify-content-between align-items-center">
                            <div className="flex-grow-1">
                                <h6 className="py-2 pl-2 text-white">Jobs</h6>
                            </div>
                            <input
                                type="textbox"
                                placeholder="Filter"
                                className="pr-2 py-1 w-25 mr-2"
                                value={this.state.filter}
                                onChange={this.handleFilter}
                                onKeyUp={this.handleFilterEnter}
                                name="filter"
                            />
                            {this.props.filterOptions && (
                                <div className="pr-2 w-25">
                                    <JobFilter options={this.props.filterOptions} onChange={this.handleStatus} />
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <JobList
                    data={this.state.data}
                    onClick={this.handleClick}
                    onDelete={this.handleDelete}
                    markComplete={this.handleMarkCompleteClick}
                    manager_review={this.props.manager_review}
                    superadmin_review={this.props.superadmin_review}
                    toggleOnHold={this.toggleOnHold}
                />
                <ReactPaginate
                    previousLabel={'previous'}
                    nextLabel={'next'}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={this.state.pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={this.handlePageClick}
                    containerClassName={'pagination'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                />
                {this.state.loading ? <div className="processing-card card">Processing...</div> : null}

                {showOnHoldModal && (
                    <div
                        className={`modal fade${showOnHoldModal ? ' show d-block' : ''}`}
                        id="jobsOnHoldModal"
                        tabIndex="-1"
                        role="dialog"
                        aria-labelledby="jobsOnHoldModalLabel"
                        aria-hidden={!showOnHoldModal}
                        style={{
                            backgroundColor: showOnHoldModal ? 'rgba(0,0,0,0.5)' : 'transparent',
                        }}
                    >
                        <div className="modal-dialog" role="document">
                            <form id="jobsOnHoldForm" onSubmit={this.handleOnHoldSubmit}>
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="jobsOnHoldModalLabel">
                                            Job On Hold
                                        </h5>
                                        <button
                                            type="button"
                                            className="close"
                                            aria-label="Close"
                                            onClick={this.closeModal}
                                        >
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <input
                                            type="hidden"
                                            id="jobId"
                                            name="jobId"
                                            value={currentJob?.id || ''}
                                            readOnly
                                        />
                                        <div className="form-group">
                                            <label htmlFor="holdReason">Reason for putting job on hold</label>
                                            <textarea
                                                className="form-control"
                                                id="holdReason"
                                                name="holdReason"
                                                required
                                                value={holdReason}
                                                onChange={(e) =>
                                                    this.setState({
                                                        holdReason: e.target.value,
                                                    })
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" onClick={this.closeModal}>
                                            Close
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn btn-cw-primary"
                                            id="saveHoldReasonBtn"
                                            disabled={isSaveDisabled}
                                        >
                                            {saveBtnText}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                )}
            </Fragment>
        );
    }
}

if (document.getElementById('jobs-table')) {
    let element = document.getElementById('jobs-table');
    let filterOptions = element.dataset.filter ? element.dataset.filter : 0;
    ReactDOM.render(
        <JobsTable
            url={element.dataset.url}
            perPage={10}
            filterOptions={filterOptions ? JSON.parse(element.dataset.filter) : null}
            success={element.dataset.success}
            error={element.dataset.error}
            manager_review={element.dataset.manager_review}
            superadmin_review={element.dataset.superadmin_review}
            operations={element.dataset.operations}
        />,
        element
    );
}

export default JobsTable;
